import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, MenuItem, SelectField, Stack, Typography } from '@curves/ui-base';

import { useChartContext } from "@Local/Dashboard/Components/ChartContext";
import useChartAdvancedFilterApi from "@Apis/useChartAdvancedFilterApi";
import { chartTypeMap, dataTypeMap, filterTargetTypeMap } from "@Local/Dashboard/staticData";
import ClubSelectBox from "./ClubSelectBox";
import RuleTaggedSelectBox from "./RuleTaggedSelectBox";
import ChartAdvancedTaggedResultBox from "./ChartAdvancedTaggedResultBox";
import StatisticsDataTypeSelectBox from "@Local/Dashboard/Components/ChartAdvancedFilter/StatisticsDataTypeSelectBox";
import { filter } from "lodash";
import ChartAdvancedStatisticsResultBox from "@Local/Dashboard/Components/ChartAdvancedFilter/ChartAdvancedStatisticsResultBox";
const ChartAdvancedBar = () => {
    const {
        dataType,
        setDataType,
        chartType,
        setChartType,
        selectedFilter,
        setSelectedFilter,
        setSelectedStatistics,
    } = useChartContext();
    const [filterOptions, setFilterOptions] = useState(null);
    const { getChartAdvFilterOptionsApi } = useChartAdvancedFilterApi()
    const initOptions = async () => {
        const resp = await getChartAdvFilterOptionsApi();
        if (resp) setFilterOptions(resp);
    }
    const handleChangeDataType = (e) => {
        setDataType(e.target.value);
        setSelectedFilter(filter(selectedFilter, item =>
            item.targetType === filterTargetTypeMap.singleClub || item.targetType === filterTargetTypeMap.clubTag));
        setSelectedStatistics([]);
    }
    useEffect(() => {
            !filterOptions && initOptions();
        },
        // eslint-disable-next-line
        []
    );
    return (
        <Box>
            <Typography>圖表類型</Typography>
            <Stack direction="row" spacing={1}>
                <SelectField defaultValue={dataType} onChange={handleChangeDataType} tabIndex={-1}>
                    <MenuItem value="" disabled>
                        <em>請選擇</em>
                    </MenuItem>
                    <MenuItem value={dataTypeMap.tagged}>
                        <em>標籤查詢</em>
                    </MenuItem>
                    <MenuItem value={dataTypeMap.statisticsMemberAbout}>
                        <em>會籍/服務/顧客製造</em>
                    </MenuItem>
                    <MenuItem value={dataTypeMap.statisticsNonMembership}>
                        <em>非會籍-商品/HC</em>
                    </MenuItem>
                    <MenuItem value={dataTypeMap.statisticsCoach}>
                        <em>教練</em>
                    </MenuItem>
                </SelectField>
                <SelectField defaultValue={chartType} onChange={(e) => setChartType(e.target.value)}>
                    <MenuItem value="" disabled>
                        <em>請選擇</em>
                    </MenuItem>
                    <MenuItem value={chartTypeMap.bar}>
                        <em>長條圖</em>
                    </MenuItem>
                    <MenuItem value={chartTypeMap.totalBar}>
                        <em>堆疊長條圖(總計)</em>
                    </MenuItem>
                    <MenuItem value={chartTypeMap.totalPercentBar}>
                        <em>堆疊長條圖(百分比)</em>
                    </MenuItem>
                    <MenuItem value={chartTypeMap.line}>
                        <em>曲線圖</em>
                    </MenuItem>
                    <MenuItem value={chartTypeMap.pie}>
                        <em>圓餅圖</em>
                    </MenuItem>
                </SelectField>
            </Stack>
            <Divider className="my-2" />
            <Typography>店舖條件</Typography>
            <Card className="my-2">
                <Card.CardContent className="p-2 px-2">
                    <ClubSelectBox sourceData={filterOptions} />
                </Card.CardContent>
            </Card>
            <Divider className="my-2" />
            <Typography>搜尋條件</Typography>
            <Card className="my-2">
                <Card.CardContent className="p-2 px-2">
                    {dataType === dataTypeMap.tagged
                        ? (<RuleTaggedSelectBox sourceData={filterOptions} />)
                        : (<StatisticsDataTypeSelectBox sourceData={filterOptions} />)}
                </Card.CardContent>
            </Card>
            <Divider className="my-2" />
            <Typography>顯示分類</Typography>
            {dataType === dataTypeMap.tagged
                ? (<ChartAdvancedTaggedResultBox dataType={dataType} chartType={chartType} options={filterOptions} />)
                : (<ChartAdvancedStatisticsResultBox dataType={dataType} chartType={chartType} options={filterOptions} />)
            }
        </Box>
    );
}
export default ChartAdvancedBar;